<template lang='pug'>
  .services-card.component
    h5.heading {{ $t('Select Service') }}
    select(v-model='category_id' required)
      option(value='') {{ $t('Display All') }}
      option(v-for='c in categories' :value='c.id') {{ c.title }}

    .services-container
      bf-flex.service( v-for='service in srvs' :key='service.id')
        input(
          type='radio' 
          v-model='service_id'
          :value='service.id'
          @input="$emit('input', $event.target.value)"
        )
        span.ellipsis {{ service.title }} ({{ service.duration }} {{ $t('mins') }})
</template>

<script>
  export default {
    name: 'services-card.component',

    props: ['categories', 'srvs'],

    data() {
      return {
        category_id: '',
        service_id: ''
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .services-card
    padding 16px

    .heading
      text-align center
    > *
      margin-top 16px
      &:first-child
        margin-top 0

  select
    width auto
    margin 0 auto
    margin-top 8px
    border 1px solid rgba( 0 0 0 .25 )
    border-radius 16px
    padding 6px 16px

  .services-container
    max-width 200px
    margin 12px auto 8px
    .service
      margin-bottom 12px
      color rgb(0 200 255)
      font-weight bold
      span
        margin-left 8px
        margin-top 1.5px
</style>
